<div class="edit-avatar-panel-container">
    <span class="edit-avatar--header">Select your preferred avatar</span>
    <div class="edit-avatar-choose">
        @for (item of avatarOptions; track item) {
            <div>
                <div class="edit-avatar-option">
                    <img
                        referrerpolicy="no-referrer"
                        [alt]="'Avatar Option'"
                        (click)="changeSelected(item.url)"
                        [attr.src]="item.url"
                        [ngClass]="getAvatarClass(item.url)"
                    />
                    <span>{{ item.source }}</span>
                </div>
            </div>
        }
        <div class="edit-avatar-option">
            <div
                class="edit-avatar-constraints upload-avatar-icon"
                (click)="launchGravatar()"
            >
                <tapestry-icon
                    [name]="'add'"
                    [size]="IconSize.Large"
                ></tapestry-icon>
            </div>
            <div>Add an avatar</div>
        </div>
    </div>
    <tapestry-inline-message-box
        content="Change your avatar by selecting from those available, or add an avatar
    to your collection through Gravatar."
        class="edit-avatar--inline-message"
    ></tapestry-inline-message-box>
</div>
